import React from 'react';
import SEO from '../../../Components/SEO';
import Breadcrumb from '../../../Components/Breadcrumb';
import { ActivityLayout } from '../../../Components/activity-layout';

const ORGANIZATION = {
  '@type': 'Organization',
  name: 'English Exam Exercises',
  url: 'https://englishexamexercises.com',
  logo: {
    '@type': 'ImageObject',
    url: 'https://englishexamexercises.com/logo.png',
  },
};

const AUTHOR = {
  '@type': 'Person',
  name: 'English Exam Exercises Team',
  url: 'https://englishexamexercises.com/about',
};

const generateArticleSchema = ({ title, description, image, url, datePublished, dateModified }) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: title,
  description,
  image: image ? [image] : undefined,
  author: AUTHOR,
  publisher: ORGANIZATION,
  datePublished,
  dateModified: dateModified || datePublished,
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': url,
  },
  articleSection: 'Teaching English',
  inLanguage: 'en-US',
});

const TeachEnglishPageLayout = ({
  title,
  eyebrow = 'Teaching Guide',
  image,
  intro,
  seoContent = [],
  levels = [],
  seoTitle,
  seoDescription,
  children,
  datePublished = '2026-10-18',
  dateModified = '2026-10-18',
}) => {
  const pageUrl = typeof window !== 'undefined' ? window.location.href : `https://englishexamexercises.com/teach-english/${title.toLowerCase().replace(/\s+/g, '-')}`;
  
  const articleSchema = generateArticleSchema({
    title: seoTitle || title,
    description: seoDescription || intro,
    image,
    url: pageUrl,
    datePublished,
    dateModified,
  });

  return (
    <ActivityLayout
      title={title}
      eyebrow={eyebrow}
      image={image}
      intro={intro}
      seoContent={seoContent}
      levels={levels}
    >
      <SEO
        title={seoTitle || title}
        description={seoDescription || intro}
        type="article"
        image={image}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />
      <Breadcrumb />
      {children}
    </ActivityLayout>
  );
};

export default TeachEnglishPageLayout;